/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState, useAppDispatch } from '../../reducers';
import { loadSurveyList, selectMostRecentSurvey } from '../../slice/initiativeSurveyListSlice';
import { Loader } from '@g17eco/atoms/loader';
import { Redirect, useRouteMatch } from 'react-router';
import { ROUTES } from '../../constants/routes';
import { generateUrl } from '../util';
import { useLocation } from 'react-router-dom';
import { LocationDescriptor } from 'history';

enum RedirectDestinations {
  SURVEY = 'survey',
}

export const RedirectToCompanyTracker = () => {
  const [redirectUrl, setRedirectUrl] = useState<LocationDescriptor>('');

  const dispatch = useAppDispatch();
  const surveyList = useSelector((state: RootState) => state.initiativeSurveyList);
  const mostRecentSurvey = useSelector(selectMostRecentSurvey);

  const { search } = useLocation();
  const match = useRouteMatch<{ initiativeId: string; destination?: RedirectDestinations }>();
  const params = match?.params;

  React.useEffect(() => {
    const { initiativeId, destination } = params;

    if (!initiativeId) {
      return;
    }

    switch (destination) {
      case RedirectDestinations.SURVEY:
        dispatch(loadSurveyList(initiativeId));
    }
  }, [dispatch, params]);

  React.useEffect(() => {
    const { initiativeId, destination } = params;

    switch (destination) {
      case RedirectDestinations.SURVEY: {
        if (!surveyList.loaded || surveyList.initiativeId !== initiativeId) {
          return;
        }
        const url = mostRecentSurvey
          ? generateUrl(ROUTES.COMPANY_TRACKER_SURVEY, { initiativeId, surveyId: mostRecentSurvey._id })
          : generateUrl(ROUTES.SUMMARY, { initiativeId });

        setRedirectUrl({ pathname: url, search });
      }
    }
  }, [surveyList, mostRecentSurvey, params, search]);

  if (redirectUrl) {
    return <Redirect to={redirectUrl} />;
  }

  return <Loader />;
};
